/*
 * Store locator — search + state filtering for the "Store locator list" section.
 * Scoped to each <store-locator> element, so multiple section instances never clash.
 */

if (!customElements.get('store-locator')) {
  customElements.define(
    'store-locator',
    class StoreLocator extends HTMLElement {
      constructor() {
        super();
        this.debounceId = null;
        this.term = '';
        this.state = 'all';
      }

      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-sl-card]'));
        if (this.cards.length === 0) return;

        this.searchInput = this.querySelector('[data-sl-search]');
        this.clearButton = this.querySelector('[data-sl-clear]');
        this.filterButtons = Array.from(this.querySelectorAll('[data-sl-filter]'));
        this.emptyState = this.querySelector('[data-sl-empty]');
        this.countEl = this.querySelector('[data-sl-count]');

        if (this.searchInput) {
          this.searchInput.addEventListener('input', this.onSearch.bind(this));
          this.searchInput.addEventListener('search', this.onSearch.bind(this));
        }

        if (this.clearButton) {
          this.clearButton.addEventListener('click', this.onClear.bind(this));
        }

        this.filterButtons.forEach((button) => {
          button.addEventListener('click', this.onFilter.bind(this));
        });
      }

      disconnectedCallback() {
        if (this.debounceId) clearTimeout(this.debounceId);
      }

      onSearch(event) {
        const value = event.target.value || '';

        if (this.clearButton) this.clearButton.hidden = value.trim() === '';

        if (this.debounceId) clearTimeout(this.debounceId);
        this.debounceId = setTimeout(() => {
          this.term = value.trim().toLowerCase();
          this.apply();
        }, 200);
      }

      onClear() {
        if (!this.searchInput) return;

        this.searchInput.value = '';
        this.term = '';
        this.clearButton.hidden = true;
        this.apply();
        this.searchInput.focus();
      }

      onFilter(event) {
        const button = event.currentTarget;
        const value = button.dataset.slFilter || 'all';
        if (value === this.state) return;

        this.state = value;

        this.filterButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.apply();
      }

      matches(card) {
        if (this.state !== 'all' && (card.dataset.state || '') !== this.state) return false;
        if (this.term === '') return true;

        return (card.dataset.search || '').indexOf(this.term) !== -1;
      }

      apply() {
        let visible = 0;

        this.cards.forEach((card) => {
          const show = this.matches(card);
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (this.emptyState) this.emptyState.hidden = visible !== 0;

        this.updateCount(visible);
      }

      updateCount(visible) {
        if (!this.countEl) return;

        const template = this.countEl.dataset.countTemplate || '';
        if (template === '') return;

        const total = this.countEl.dataset.countTotal || this.cards.length;

        this.countEl.textContent = template.replace('[count]', visible).replace('[total]', total);
      }
    }
  );
}
